// Password policy for AXO signal. The hard requirement enforced by the API is
// 8+ characters; the remaining rules are advisory strength criteria shown by
// Arc's PasswordStrength meter, so the meter matches what the app accepts.
export const AXO_PASSWORD_RULES = [
  {
    id: "length",
    label: "At least 8 characters",
    test: (password) => password.length >= 8,
    remaining: (password) => Math.max(0, 8 - password.length),
  },
  {
    id: "case",
    label: "Upper and lowercase letters",
    test: (password) => /[a-z]/.test(password) && /[A-Z]/.test(password),
  },
  {
    id: "number",
    label: "At least one number",
    test: (password) => /\d/.test(password),
  },
  {
    id: "symbol",
    label: "At least one symbol",
    test: (password) => /[^A-Za-z0-9\s]/.test(password),
  },
];
